<div class="deliveryInstructionLanding">
  <h3 class="margin-b15">CPP Contact List</h3>
  <div class="row">
    <div class="col-lg-11 col-md-9 pr-0">
      <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
    </div>
  </div>

  <div class="fulfill-top-sec">
    <div class="row listing-action-items">
      <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0 margin-l-8">
      </div>
      <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10 padding-b10">
        <span class="margin-l20 text-right smallPadLeft0 smallMarLeft0 valignTop">
          <button *ngIf="accessTypeMode" mat-raised-button class="btns margin-l5" color="primary" (click)="addEditDeliveryInstruction()">Create New Records</button>
        </span>
      </div>
    </div>
  </div>
  <div class="tableContainer growertableContainer">
    <table mat-table #deliveryInstructionTable [dataSource]="deliveryInstructionDataSource" matSort #deliveryInstructionSort matSortDirection="desc" class="matTables">
      <ng-container matColumnDef="accountName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipTo">Account Name</th>
        <td mat-cell *matCellDef="let element" class="order-info" (click)="navigateToEditDeliveryInstructions(element)">
          <p class="grower-name">
            <a>
              {{element.accountName}}
            </a>
          </p>
          <p>
            {{element.address1}},  {{element.city}}, {{element.state}} - {{element.zipCode}}
          </p>
        </td>
      </ng-container>
      <ng-container matColumnDef="accountNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="dealerReleaseNo">Account #</th>
        <td mat-cell *matCellDef="let element" class="text-left">
          {{element.accountNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="branch">Updated By</th>
        <td mat-cell *matCellDef="let element" class="text-left">
          {{element.updateUser}}
        </td>
      </ng-container>
      <ng-container matColumnDef="dateUpdated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestedDate">Date Updated</th>
        <td mat-cell *matCellDef="let element" class="text-left">
          {{element.updateTimeStamp | date:'MM/dd/yyyy' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedDeliveryInstructionColumns;sticky:true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedDeliveryInstructionColumns;"></tr>
    </table>
  </div>
</div>
